import React from 'react';
import { Box, Typography, Stack } from '@mui/material';

interface ServiceInfoSectionProps {
  account: any;
}

export const ServiceInfoSection: React.FC<ServiceInfoSectionProps> = ({ account }) => (
  <Box>
    <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
      Service Information
    </Typography>
    <Stack spacing={1}>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
        <Box>
          <Typography variant="body2">
            <strong>Service Date:</strong>{' '}
            {account.encounterInfo?.serviceDate
              ? new Date(account.encounterInfo.serviceDate).toLocaleDateString()
              : 'N/A'}
          </Typography>
        </Box>
        <Box>
          <Typography variant="body2">
            <strong>Account Type:</strong> {account.accountServiceType || 'N/A'}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
        <Box>
          <Typography variant="body2">
            <strong>Payer:</strong> {account.primaryPayerInfo?.payerName || 'N/A'}
          </Typography>
        </Box>
        <Box>
          <Typography variant="body2">
            <strong>Physician:</strong> {account.physician?.firstName} {account.physician?.lastName}
          </Typography>
        </Box>
      </Box>
    </Stack>
  </Box>
);

export default ServiceInfoSection;
